import React from 'react';
import { Link } from 'react-router-dom';
import './NavigationButtons.css';

const NavigationButtons = ({ prevPath, nextPath, onBack, subjectPath, subtopics = [] }) => {
    const navigationState = { subtopics, subjectPath };

    return (
        <div className="navigation-buttons">
            <div className="nav-button-group">
                {/* Back Button */}
                <div className="nav-button-item nav-button-left">
                    {prevPath ? (
                        <Link to={prevPath} state={navigationState} className="nav-button nav-back" title="Go to previous subtopic">
                            ← Back
                        </Link>
                    ) : onBack ? (
                        <button onClick={onBack} className="nav-button nav-back" title="Go to previous subtopic">
                            ← Back
                        </button>
                    ) : (
                        <div className="nav-button nav-button-disabled"></div>
                    )}
                </div>

                {/* Subject Module Button */}
                <div className="nav-button-item nav-button-center">
                    {subjectPath ? (
                        <Link to={subjectPath} className="nav-button nav-subject" title="Return to subject module">
                            ↑ Subject
                        </Link>
                    ) : (
                        <div className="nav-button nav-button-disabled"></div>
                    )}
                </div>

                {/* Next Button */}
                <div className="nav-button-item nav-button-right">
                    {nextPath ? (
                        <Link to={nextPath} state={navigationState} className="nav-button nav-next" title="Go to next subtopic">
                            Next →
                        </Link>
                    ) : (
                        <div className="nav-button nav-button-disabled"></div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default NavigationButtons;
